import classNames from "classnames";
import { memo, ReactNode } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import * as standaloneTableCss from "./redo-standalone-table.module.css";
import { RedoTable, RedoTableLayout, RedoTableSize } from "./redo-table";

export interface RedoStandaloneTableProps<T> {
  tableData: T[];
  layout: RedoTableLayout<T>;
  header?: { title: string; button?: ReactNode };
  size?: RedoTableSize;
  emptyStateContent?: ReactNode;
}

export const RedoStandaloneTable = memo(function RedoStandaloneTable<T>({
  tableData,
  layout,
  header,
  size = "md",
  emptyStateContent,
}: RedoStandaloneTableProps<T>) {
  return (
    <Flex data-arbiter="RedoStandaloneTable" dir="column" gap="xl" w="full">
      <Flex dir="column" gap="none">
        {header && (
          <Flex
            align="center"
            bgColor="primary"
            borderBottomWidth="none"
            borderColor="primary"
            borderStyle="solid"
            borderWidth="1px"
            bottomLeftRadius="none"
            bottomRightRadius="none"
            justify="space-between"
            p="xl"
            radius="sm"
          >
            <Text fontSize="md" fontWeight="semibold">
              {header.title}
            </Text>
            {header.button}
          </Flex>
        )}
        <RedoTable
          additionalClasses={classNames(
            standaloneTableCss.standaloneTable,
            header && standaloneTableCss.withExtraHeader,
          )}
          emptyStateContent={emptyStateContent}
          layout={layout}
          rowsOfData={tableData}
          size={size}
        />
      </Flex>
    </Flex>
  );
}) as <T>(props: RedoStandaloneTableProps<T>) => JSX.Element;
